import * as React from "react";
import { useState, useEffect } from "react";
import { Tab, Tabs } from "@mui/material";
import { TabPanel } from "../common/TabPanel.js";
import EditableField from "../common/EditableField.tsx";
import HistoricalDataTable from "../common/HistoricalDataTable.js";
import type { Schema } from "../../amplify/data/resource";
import { generateClient } from "aws-amplify/data";

const client = generateClient<Schema>();

export default function GRStrategies() {
  const [currentTab, setCurrentTab] = useState(1);
  const [grStrategies, setGrStrategies] = useState<Schema["GrStrategies"]["type"][]>([]);
  const [grActivities, setGrActivities] = useState<Schema["GrActivities"]["type"][]>([]);

  const handleChange = (event, index) => {
    setCurrentTab(index);
  };

  useEffect(() => {
    let sub = client.models.GrStrategies.observeQuery().subscribe({
      next: ({ items }) => {
        setGrStrategies([...items].sort(function(a,b) {
            return new Date(b.updatedAt) - new Date(a.updatedAt);
          }));
      },
    });
    sub = client.models.GrActivities.observeQuery().subscribe({
        next: ({ items }) => {
          setGrActivities([...items].sort(function(a,b) {
            return new Date(b.updatedAt) - new Date(a.updatedAt);
          }));
        },
      });

    return () => sub.unsubscribe();
  }, []);

  return (
    <div className="dashboard">
      <Tabs value={currentTab} onChange={handleChange}>
        <Tab value={1} label="GR Strategies" />
        <Tab value={2} label="GR Activities" />
      </Tabs>
      <TabPanel value={currentTab} index={1}>
        <h1>GR Strategies</h1>
        <p>
          Develop and execute Pro-Employee Action Committee (PEAC)
          recommendations. The intent is to create a public dialogue of Maximus
          labor position with internal and external stakeholders. The action is
          to change Congressional sentiment toward amending the Service Contract
          Act as a better alternative to the current LHA position.
        </p>
        <br />
        {grStrategies?.length > 0 && 
        <>            
            <div className="boxes">
                <EditableField
                    category="Client/Agency"
                    sentiment={grStrategies?.find((g) => g.category === "Client/Agency")?.sentiment}
                    content={grStrategies?.find((g) => g.category === "Client/Agency")?.description}
                    editableContent={grStrategies?.find((g) => g.category === "Client/Agency")?.statementOfStrategy}
                    dashboardType="GrStrategies"
                />
                <EditableField
                    category="Legislative"
                    sentiment={grStrategies?.find((g) => g.category === "Legislative")?.sentiment}
                    content={grStrategies?.find((g) => g.category === "Legislative")?.description}
                    editableContent={grStrategies?.find((g) => g.category === "Legislative")?.statementOfStrategy}
                    dashboardType="GrStrategies"
                />
                <EditableField
                    category="Advocacy"
                    sentiment={grStrategies?.find((g) => g.category === "Advocacy")?.sentiment}
                    content={grStrategies?.find((g) => g.category === "Advocacy")?.description}
                    editableContent={grStrategies?.find((g) => g.category === "Advocacy")?.statementOfStrategy}
                    dashboardType="GrStrategies"
                />
            </div>
            <br />
            <p style={{ fontSize: "20px" }}>Historical Data</p>
            <HistoricalDataTable 
                headers={[ "Date", "Category", "Sentiment", "Description"]}
                rows={grStrategies}
                fields={["date", "category", "sentiment", "statementOfStrategy"]}
                filterableFields={["Date", "Category", "Sentiment"]}
            />
        </>}
      </TabPanel>
      <TabPanel value={currentTab} index={2}>
        <h1>GR Activities</h1>
        <p>
          Current focus is on execution of the Pro-Employee Action Committee
          (PEAC) campaign founded in the recommendations of the Strategic
          Engagement Task Force (SETF). Specifically, actions to overcome client
          sentiment and motivations related to key contracts such as the CMS
          Customer Contact Center, VA Veterans Evaluation Services and Federal
          Student Loans.
        </p>
        <br />
        {grActivities?.length > 0 && 
        <>  
            <div className="boxes">
                <EditableField
                    category="Client/Agency"
                    sentiment={grActivities?.find((g) => g.category === "Client/Agency")?.sentiment}
                    content={grActivities?.find((g) => g.category === "Client/Agency")?.description}
                    editableContent={grActivities?.find((g) => g.category === "Client/Agency")?.additionalDescription}
                    dashboardType="GrActivities"
                />
                <EditableField
                    category="Legislative"
                    sentiment={grActivities?.find((g) => g.category === "Legislative")?.sentiment}
                    content={grActivities?.find((g) => g.category === "Legislative")?.description}
                    editableContent={grActivities?.find((g) => g.category === "Legislative")?.additionalDescription}
                    dashboardType="GrActivities"
                />
                <EditableField
                    category="Advocacy"
                    sentiment={grActivities?.find((g) => g.category === "Advocacy")?.sentiment}
                    content={grActivities?.find((g) => g.category === "Advocacy")?.description}
                    editableContent={grActivities?.find((g) => g.category === "Advocacy")?.additionalDescription}
                    dashboardType="GrActivities"
                />
            </div>
            <br />
            <p style={{ fontSize: "20px" }}>Historical Data</p>
            <HistoricalDataTable
                headers={["Date", "Category", "Sentiment", "Description"]}
                rows={grActivities}
                fields={["date", "category", "sentiment", "additionalDescription"]}
                filterableFields={["Date", "Category", "Sentiment"]}
            />
        </>}
      </TabPanel>
    </div>
  );
}